import React, { useState } from 'react'
import Color from '../../../Components/Colors/Color'
import ClipLoader from 'react-spinners/ClipLoader'
import { useNavigate } from 'react-router-dom'
import '../Overlay/Overlay.css'
import './LogOut.css'
import { useLogOutStateContext } from '../../../Contexts/LogOutContext'

const LogOut = () => {

    const navigate = useNavigate();

    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const {showOverlayLogOut, setShowOverlayLogOut} = useLogOutStateContext();

    const handleCloseOverlay = () =>{
        setShowOverlayLogOut(prevState=>({
            ...prevState,
            overlay:false
        }));
        document.body.classList.remove('body-no-scroll');
    }

    const handleLogOut = () =>{
        setShowOverlayLogOut(prevState=>({
            ...prevState,
            overlay:false
        }));
        document.body.classList.remove('body-no-scroll');
        const token = localStorage.getItem('authToken');
        if(token){
            localStorage.removeItem('authToken');
        }
        navigate("/admin");
    }

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    }

  return (
    <div className="overlay-container logout" style={{color: Color.thirdText}} onClick={handleCloseOverlay}>
        <div className={`overlay-content`} onClick={handleStopPropagation}>
            <h4 className={`delete-overlay-header`}>Logout</h4>
            <h6 className={`delete-overlay-text`}>Are you sure to log out?</h6>
            <div className="delete-overlay-btn-container">
                <button className={`delete-overlay-cancel-btn logout`} onClick={handleCloseOverlay}>
                    No
                </button>
                <button className={`delete-overlay-ok-btn logout`} onClick={handleLogOut}>
                    Yes 
                </button>
            </div>
            <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                    <ClipLoader color='white' size={100} />
            </div>
        </div>
    </div>
  )
}

export default LogOut;
